export const SITE_URL = 'https://throughpilot.com'
export const SITE_NAME = 'ThroughPilot'
export const DEFAULT_OG_IMAGE = '/brand/og.png'

type SeoOptions = {
  title: string
  description: string
  path: string
  image?: string
  type?: 'website' | 'article'
  noindex?: boolean
}

export function absoluteUrl(path: string) {
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}

export function seoMeta({
  description,
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  path,
  title,
  type = 'website',
}: SeoOptions) {
  const imageUrl = absoluteUrl(image)
  const url = absoluteUrl(path)

  return [
    { title },
    { name: 'description', content: description },
    {
      name: 'robots',
      content: noindex
        ? 'noindex, nofollow, noarchive'
        : 'index, follow, max-image-preview:large',
    },
    { property: 'og:site_name', content: SITE_NAME },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: type },
    { property: 'og:url', content: url },
    { property: 'og:image', content: imageUrl },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: imageUrl },
  ]
}

export function canonicalLink(path: string) {
  return { rel: 'canonical', href: absoluteUrl(path) }
}

export function jsonLd(data: Record<string, unknown>) {
  return {
    type: 'application/ld+json',
    children: JSON.stringify(data).replace(/</g, '\\u003c'),
  }
}

export function organizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: SITE_URL,
    logo: absoluteUrl('/brand/icon-512.png'),
    image: absoluteUrl(DEFAULT_OG_IMAGE),
    description:
      'Senior Product Engineering for AI-era builds, from MVPs and AI prototypes to production-ready apps.',
    areaServed: 'Worldwide',
    email: 'hello@throughpilot.com',
    sameAs: ['https://throughpilot.com'],
  }
}

export function webSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: SITE_NAME,
    url: SITE_URL,
    publisher: { '@id': `${SITE_URL}/#organization` },
  }
}
